class SensorLogSecs {

  constructor () {

    this.send_intervals = [
      { label: '48 hours', value: 172800 },
      { label: '24 hours', value: 86400 },
      { label: '12 hours', value: 43200 },
      { label: '6 hours', value: 21600 },
      { label: '3 hours', value: 10800 },
      { label: '2 hours', value: 7200 },
      { label: '1 hour', value: 3600 },
      { label: '30 minutes', value: 1800 },
    ];

  }

  updateLogIntervals($settings, send_interval) {

    const $logSecs = $settings.find('select[name="log_secs"]');

    if($logSecs.length === 0) {
      return;
    }

    const log_secs = $logSecs.val();
    const options = this.renderLogIntervals(log_secs, send_interval);

    $logSecs.html(options);

  }

  renderLogIntervals(log_secs, send_interval) {

    let options = '';

    this.send_intervals.forEach(interval => {

      if(interval.value <= send_interval) {
        return;
      }

      options += `
      <option value="${interval.value}" ${interval.value == log_secs ? 'selected' : ''}>
        ${interval.label}
      </option>
    `;

    });

    return options;

  }

  render(sensor) {

    if(parseInt(sensor.version) < 2013) {
      return '';
    }

    const options = this.renderLogIntervals(sensor.log_secs, sensor.send_interval);

    let html = `
  
  <div class="divider"></div>
  
  <div class="setting">
        
    <h3>Battery Saver Mode</h3>

      <div class="setting__input">
        
        <div class="setting__switch">
          <div class="setting__switch__value">
            <div class="switch medium">
              <input class="switch-input" type="checkbox" id="use_log_mode" name="use_log_mode" value="1" ${sensor.use_log_mode == 1 ? 'checked' : ''} />
              <label class="switch-paddle" for="use_log_mode">
                <span class="switch-active">On</span>
                <span class="switch-inactive">Off</span>
              </label>
            </div>
          </div>
          <div class="setting__switch__label">Instant alerts but fewer uploads to save battery</div>
        </div>

      </div>
    </div>
    
    <div class="setting setting--conditional ${sensor.use_log_mode == 1 ? 'is-active' : ''}" data-for="use_log_mode">
        
        <div class="setting">
          <p class="setting__description">Note: while in log mode your sensor will still instantly send alerts</p>    
          <div class="setting__input">
            <div class="setting__label">Upload Logs Every:</div>
            <select class="settings-select" name="log_secs">
              ${options}
            </select>
          </div>
        </div>

    </div>
  `;

    return html;

  }


}

export default SensorLogSecs;
